import { makeStyles } from '@mui/styles';

export const useBreadcrumbStyles = makeStyles(() => ({
  breadcrumb: {
    cursor: 'pointer',
  },
}));
